import { BrowserModule } from '@angular/platform-browser';
import { Http, HttpModule } from '@angular/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ServiceCaller } from './services/ServiceCaller';
import { AuthGuard } from './services/AuthGuard';
import { AuthService } from './services/AuthService';
import { DevExtremeModule } from "devextreme-angular";
import { DXGridToolbarComponent, DXGridToolbarDataSourceComponent } from './components/dx-gridtoolbar.component';
import { UIService } from './services/UIService';
import { CKEditorModule } from 'ng2-ckeditor';
import { FormsModule } from '@angular/forms';

export function CanAlwaysActivateGuard(): boolean {
    return true
}

@NgModule({
    imports: [
        CommonModule,
        HttpModule,
        RouterModule,
        DevExtremeModule,
        CKEditorModule,
        FormsModule,
    ],
    declarations: [
        DXGridToolbarDataSourceComponent,
        DXGridToolbarComponent
    ],
    providers: [
        ServiceCaller,
        UIService,
        AuthGuard,
        AuthService,
        {
            provide: 'CanAlwaysActivateGuard',
            useValue: CanAlwaysActivateGuard
        }
    ],
    exports: [
        DevExtremeModule,
        RouterModule,
        DXGridToolbarDataSourceComponent,
        DXGridToolbarComponent,
        CKEditorModule,
        FormsModule,
    ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/shared/shared.module.ts